export type ViewableKind = "image" | "pdf" | "spreadsheet" | "text" | "office" | "unsupported";

const ext = (fileName: string) => fileName.split(".").pop()?.toLowerCase() || "";

export const detectViewableKind = (fileType?: string | null, fileName = ""): ViewableKind => {
  const e = ext(fileName);
  const t = (fileType || "").toLowerCase();

  if (t.startsWith("image/") || ["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg", "avif"].includes(e)) {
    return "image";
  }
  if (t === "application/pdf" || t.includes("pdf") || e === "pdf") return "pdf";
  if (
    t.includes("spreadsheet") ||
    t.includes("excel") ||
    t === "text/csv" ||
    ["xlsx", "xls", "xlsm", "csv"].includes(e)
  ) {
    return "spreadsheet";
  }
  if (
    t.startsWith("text/") ||
    t === "application/json" ||
    ["txt", "md", "markdown", "json", "log"].includes(e)
  ) {
    return "text";
  }
  if (
    t.includes("word") ||
    t.includes("officedocument") ||
    t.includes("powerpoint") ||
    t.includes("msword") ||
    ["doc", "docx", "ppt", "pptx", "rtf", "odt", "odp"].includes(e)
  ) {
    return "office";
  }
  return "unsupported";
};

export const officeViewerUrl = (url: string) =>
  `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;

export const isIosSafari = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && (navigator as any).maxTouchPoints > 1);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|Chrome/.test(ua);
  return isIos && isSafari;
};

/**
 * Open a tab synchronously on the user's click, then navigate it once the URL
 * is resolved. Falls back to same-tab navigation when popups are blocked.
 * Call `openBlankTab()` inside the click handler BEFORE any await.
 */
export const openBlankTab = (): Window | null => {
  try {
    return window.open("about:blank", "_blank");
  } catch {
    return null;
  }
};

export const navigateOpenedTab = (win: Window | null, url: string) => {
  if (win && !win.closed) {
    win.location.href = url;
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const openUrlInNewTab = (url: string) => navigateOpenedTab(openBlankTab(), url);

export const triggerDownload = (url: string, fileName: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
